/**
 * The one place the frontend decides where the backend lives (#2339).
 *
 * The backend serves everything under `/api/*`, so a build deployed on the
 * same origin as the backend needs no URL at all: an empty string makes every
 * request same-origin relative. Consumers that need an absolute URL (Better
 * Auth client, maplibre/pmtiles) use `getBackendUrl() || window.location.origin`.
 */
type BackendUrlEnv = { DEV: boolean; VITE_BACKEND_URL?: string };

/** DEV → explicit URL or the local wrangler dev server; any build → explicit URL or "" (same-origin relative). */
export function resolveBackendUrl(env: BackendUrlEnv): string {
  const fromEnv = env.VITE_BACKEND_URL ?? '';
  if (env.DEV) return fromEnv || 'http://localhost:8787';
  return fromEnv;
}

export const getBackendUrl = (): string => resolveBackendUrl(import.meta.env);
